import { createSelector } from 'reselect'
import { getLoyaltyEsimUpsellCartItem } from 'loyalty/lib/esims/esimCheckoutUtils'
import getCanShowCheckoutLoyaltyEsimBenefit from './getCanShowCheckoutLoyaltyEsimBenefit'
import getIsCheckoutModeEligibleForLoyaltyEsim from './getIsCheckoutModeEligibleForLoyaltyEsim'

/** Checkout eSIM tile display, including selected paid upsells. */
const getCanShowCheckoutLoyaltyEsimTile = createSelector(
  (state: App.State) => getCanShowCheckoutLoyaltyEsimBenefit(state),
  (state: App.State) => getIsCheckoutModeEligibleForLoyaltyEsim(state),
  (state: App.State) => getLoyaltyEsimUpsellCartItem(state.checkout.cart.items),
  (
    canShowIncludedLoyaltyEsimBenefit,
    isCheckoutModeEligibleForLoyaltyEsim,
    selectedEsimUpsell,
  ): boolean =>
    canShowIncludedLoyaltyEsimBenefit ||
    (isCheckoutModeEligibleForLoyaltyEsim && !!selectedEsimUpsell),
)

export default getCanShowCheckoutLoyaltyEsimTile
